import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@app/services/auth.service';
import { Router } from '@angular/router';
import { getErrorMessage, validatePhoneNumber } from '@app/commons/utils/utils';
import { ViewConfig } from '@app/commons/utils/view-config';
import { UserService } from '@app/services/user.service';
import { LocalStorageCacheServiceService } from '@app/services/local-storage-cache-service.service';
import { emailValidator } from '@app/commons/utils/form-utility';
import { Observable } from 'rxjs';
import { IdTokenResult, User } from '@angular/fire/auth';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator]),
    password: new FormControl('', Validators.required)
  });
  otp = new FormControl('', [Validators.required, Validators.maxLength(6)]);
  phone = new FormControl('', [Validators.required]);
  errorMessage = '';
  viewConfig = new ViewConfig();
  mfaResponse: any;
  verificationId = '';
  showVefifyOtp: boolean = false;
  showEnableMFA: boolean = false;
  showPasswordValue = false;
  errorText = '';
  idToken$!: Observable<IdTokenResult | null>;
  user$!: Observable<User | null>;
  rawPhoneNumber = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private userService: UserService,
    private cacheService: LocalStorageCacheServiceService,
  ) {
    this.idToken$ = this.authService.idToken$;
    // this.user$ = this.authService.user$;
  }

  ngOnInit() {
    this.idToken$.subscribe(async idToken => {
      if (idToken && idToken.signInSecondFactor && !this.loginForm.valid) {
        this.router.navigate(['documents']);
      }
    });
    /* this.user$.subscribe(user => {
      if (user && !this.loginForm.valid) {
        this.router.navigate(['documents']);
      }
    }); */
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.viewConfig.setLoading(true);
      this.authService.signIn(this.loginForm.value.email || '', this.loginForm.value.password || '').then(async data => {
        if (!data.user) {
          this.verificationId = await this.authService.sendOtp(data);
          this.viewConfig.loading = false;
          this.showVefifyOtp = true;
          setTimeout(() => {
            document.getElementById('enter-otp')?.focus();
          }, 200);
          this.mfaResponse = data;
          this.authService.onOTPPage = true;
        } else {
          this.showMobileNumberScreen();
        }
      }).catch(err=>{
        console.log(err);
        this.viewConfig.setError(err);
        if (getErrorMessage(err) == 'Firebase: Error (auth/user-disabled).') {
          this.showErrorMessage('Your user has been disabled, please contact your admin.');
        } else if (getErrorMessage(err) == 'Firebase: Error (auth/invalid-credential).') {
          this.showErrorMessage('Please enter a valid email and password.');
        } else {
          this.showErrorMessage(getErrorMessage(err));
        }
      });
    } else {
      this.showErrorMessage('Please enter a valid email and password.');
      this.loginForm.markAllAsTouched();
    }
  }

  showMobileNumberScreen() {
    this.authService.onOTPPage = true;
    this.showEnableMFA = true;
    this.showVefifyOtp = false;
    this.viewConfig.setLoading(false);
  }

  async initiateMFA() {
    const error = validatePhoneNumber(this.phone.value || '');
    if (error) {
      this.showErrorMessage(error);
      return;
    }
    this.viewConfig.setLoading(true);
    try {
      this.verificationId = await this.authService.setMFA('+1'+this.rawPhoneNumber || '') || '';
      this.viewConfig.setLoading(false);
      this.showEnableMFA = false;
      this.showVefifyOtp = true;
    } catch (e) {
      this.viewConfig.setLoading(false);
      this.showErrorMessage(getErrorMessage(e));
    }
  }

  async enrollMFA() {
    if (this.otp.value) {
      try {
        this.viewConfig.setLoading(true);
        await this.authService.enrollMFA(this.verificationId, this.otp.value);
        this.viewConfig.setLoading(false);
        this.setUserDetailFromDB();
        this.router.navigate(['documents']);
      } catch (error:any) {
        this.viewConfig.setLoading(false);
        if (error.code === 'auth/code-expired') {
          this.showErrorMessage('OTP Expired, You will be redirected to login page in 3 seconds.');
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          this.showInvalidOTPError(error);
        }
      }
    }
  }

  showInvalidOTPError(error:any) {
    if (error.code === 'auth/invalid-verification-code') {
      this.showErrorMessage('Invalid OTP');
      this.otp.patchValue('');
      this.viewConfig.setLoading(false);
    }
  }

  async verifyOtp() {
    if (this.otp.valid && this.otp.value) {
      this.viewConfig.setLoading(true);
      if (this.mfaResponse) {
        try {
          const userDetails = await this.authService.verifyOtp(this.mfaResponse, this.verificationId, this.otp.value);
          this.authService.isUserVerified().then(isVerified=>{
            console.log(isVerified);
            
            this.viewConfig.loading = false;
            this.authService.userInfo = userDetails;
            this.authService.onOTPPage = false;
            this.authService.isLoggedInAfterMFA = true;
            this.setUserDetailFromDB();
            this.router.navigate(['documents']);
          });
        } catch (error) {
          this.viewConfig.setLoading(false);
          this.showInvalidOTPError(error);
        }
      } else {
        this.enrollMFA();
      }
    } else {
      this.showErrorMessage('Please enter a valid OTP less than 6 digits');
      this.loginForm.markAllAsTouched();
    }
  }

  async setUserDetailFromDB() {
    this.userService.getUser(this.authService.getUserDetails?.uid || '').subscribe(userDetailsFromDB=>{
      this.cacheService.set('userDetails', userDetailsFromDB, 60*24*365);
    });
  }

  get emailControl() {
    return this.loginForm.controls.email;
  }

  get passwordControl() {
    return this.loginForm.controls.password;
  }

  resetForm() {
    this.loginForm.setValue({
      email: '',
      password: ''
    });
  }

  setForgetPassword() {
    this.router.navigate(['forgot-password']); 
  }

  get subTitle() {
    switch (true) {
      case this.showVefifyOtp:
        return 'Please enter OTP that has been sent to your registered phone number.'

      case this.showEnableMFA:
        return 'Please provide your phone number to receive an OTP'
    
      default:
        return  'Enter your credentials to access your account';
    }
  }

  get passwordIconUrl() {
    return this.showPasswordValue ? 'icons/linear/password-hide.svg' : 'icons/linear/password-show.svg'
  }

  get passwordInputType() {
    return this.showPasswordValue ? 'text' : 'password'
  }

  showErrorMessage(message: string) {
    this.errorText = message;
    setTimeout(()=>{
      this.errorText = '';
    }, 3000)
  }

  formatPhoneNumber(event: any) {
    let input = event.target.value;
    input = input.replace(/\D/g, '');
    this.rawPhoneNumber = input;
    if (input.length <= 3) {
      event.target.value = `(${input}`;
    } else if (input.length <= 6) {
      event.target.value = `(${input.slice(0, 3)}) ${input.slice(3)}`;
    } else {
      event.target.value = `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6, 10)}`;
    }
  }

  get phoneInputClass() {
    return this.phone.dirty && validatePhoneNumber(this.phone.value || '') ? 'invalid' : '';
  }

}
